import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetProductUsageResponseDto } from "../../dtos/get-product-usage-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetProductUsageQueryParams = {
  queryParams: { orderItemId: number };
  options?: Omit<UseQueryOptions<GetProductUsageResponseDto>, "queryKey">;
};

export const useGetProductUsageQuery = ({
  queryParams,
  options
}: UseGetProductUsageQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getProductUsage(queryParams.orderItemId).queryKey,
    queryFn: async () =>
      await OrderService.getProductUsage({ payload: queryParams }),
    ...options
  });
};
